<template>
    <div>
        <GoogleSheets :isPlus="isPlus"
            v-if="integrationId === 6"
            :actions="getActions"
            @done="$emit('done', $event)"
            :data="data"
        />

        <Shopify :isPlus="isPlus"
            v-if="integrationId === 5"
            :actions="getActions"
            :funnelProduct="funnelProduct"
            @done="$emit('done', $event)"
           :step-id="stepId" :funnel-id="funnelId" :product-id="productId"
            :data="data"
            :integrationId="integrationId"
            :integrations="integrations" />

        <ShipStation :isPlus="isPlus"
            v-if="integrationId === 7"
            :actions="getActions"
            @done="$emit('done', $event)"
            :data="data"
            :integrationId="integrationId"
            :integrations="integrations" />

        <Orderlytics :isPlus="isPlus"
            v-if="integrationId === 4"
            :actions="getActions"
            @done="$emit('done', $event)"
            :data="data"
            :integrationId="integrationId"
            :integrations="integrations" />

        <ActiveCampaign :isPlus="isPlus"
            v-if="integrationId === 1 || integrationId === 3 || integrationId === 8 || integrationId === 9"
            :actions="getActions"
            @done="$emit('done', $event)"
            :data="data"
            :integrationId="integrationId"
            :integrations="integrations"
        />

	    <zapier-props v-if="integrationId===13"  />

    </div>
</template>

<script>
import API from "@/api"

import ActiveCampaign from "@/components/popups/automation/integration-actions/ActiveCampaign.vue"
import GoogleSheets from "@/components/popups/automation/integration-actions/GoogleSheets.vue"
import Shopify from "@/components/popups/automation/integration-actions/shopify/Shopify"
import ShipStation from "@/components/popups/automation/integration-actions/ShipStation.vue"
import Orderlytics from "@/components/popups/automation/integration-actions/Orderlytics.vue"
import ZapierProps from "@/components/integrations/zapier-props";

export default {
    name: "Step3",
    components: {
	    ZapierProps,
        ActiveCampaign,
        GoogleSheets,
        Shopify,
        ShipStation,
        Orderlytics
    },
    mixins: [API],
    props: ['actions', 'integrationId', 'isPlus', 'funnelProduct', 'data', 'integrations', 'productId', 'stepId', 'funnelId'],
    data() {
        return {
            qty: 2,
            customerEmail: true,
            actionSelect: {
                selectValue: '',
                selectOptions: [],
            }
        }
    },
    computed: {
        getActions() {
            return this.actionSelect.selectOptions
        }
    },
    watch: {
        actions(val) {
            //console.log('actions changed: ', val);
            this.actionSelect.selectOptions = [];
            if(val.length) {
                this.actions.forEach(action=> {
                    this.actionSelect.selectOptions.push({id: action.id, text: action.caption})
                });
                //console.log('result: ', this.actionSelect.selectOptions);
            }
        }
    },
    async created() {
        if(this.actions) {
            this.actions.forEach(action=> {
                this.actionSelect.selectOptions.push({id: action.id, text: action.caption})
            });
        }

        console.log('integrationId', this.integrationId);
    },
    beforeDestroy() {
        this.$store.dispatch('updAutomation');
    }
}
</script>
